import type { ReactElement } from 'react';

import { Modal } from '@/components/Modal';

interface ConfirmDialogProps {
    isOpen: boolean;
    title: string;
    message: string;
    confirmLabel?: string;
    cancelLabel?: string;
    danger?: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

export function ConfirmDialog({
    isOpen,
    title,
    message,
    confirmLabel = 'Подтвердить',
    cancelLabel = 'Отмена',
    danger = false,
    onConfirm,
    onCancel
}: ConfirmDialogProps): ReactElement {
    return (
        <Modal isOpen={isOpen} onClose={onCancel} title={title} testId="confirm-dialog">
            <p className="text-sm text-gray-700">{message}</p>
            <div className="mt-4 flex justify-end gap-2">
                <button
                    type="button"
                    onClick={onCancel}
                    data-testid="confirm-cancel"
                    className="rounded border border-gray-300 px-4 py-2 text-sm text-gray-700 transition hover:bg-gray-100"
                >
                    {cancelLabel}
                </button>
                <button
                    type="button"
                    onClick={onConfirm}
                    data-testid="confirm-ok"
                    className={`rounded px-4 py-2 text-sm font-medium text-white transition ${
                        danger ? 'bg-red-600 hover:bg-red-700' : 'bg-gray-900 hover:bg-gray-800'
                    }`}
                >
                    {confirmLabel}
                </button>
            </div>
        </Modal>
    );
}
